import React from "react";
import { Link } from "react-router-dom";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import {
  Park as ParkIcon,
  Pets as WildlifeIcon,
  DirectionsBike as RecreationIcon,
  Castle as HistoricIcon,
  Landscape as MonumentIcon,
  Signpost as ForestServiceIcon,
  Grass as LandIcon,
  Visibility as ParksIcon,
  LocalFireDepartment as StateParksIcon,
} from "@mui/icons-material";
import ActionButton from "../utils/ActionButton";

const PlacesToVisit = () => {
  const iconData = [
    {
      icon: <ParkIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "National Forests",
      alt: "Utah National Forest",
      image: "/img/forests.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/national-forests",
    },
    {
      icon: <WildlifeIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "National Wildlife Refuges",
      alt: "Utah National Wildlife Refuges",
      image: "/img/wildlife.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/national-wildlife-refuges",
    },
    {
      icon: <RecreationIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "National Recreation Areas",
      alt: "Utah National Recreation Areas",
      image: "/img/recreation.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/national-recreation-area",
    },
    {
      icon: <HistoricIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "National Historic Site",
      alt: "National Historic Site Utah",
      image: "/img/historic.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/national-historic-site",
    },
    {
      icon: <MonumentIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "National Monuments",
      alt: "Utah National Monuments",
      image: "/img/monument.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/national-monument",
    },
    {
      icon: <ForestServiceIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "US Forest Service Wilderness Areas",
      alt: "United States Forest Service Wilderness Areas",
      image: "/img/forestService.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/national-forest-services",
    },
    {
      icon: <LandIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "Bureau of Land Management Wilderness Areas",
      alt: "Bureau of Land Management Wilderness Areas",
      image: "/img/land.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/land-management-wilderness",
    },
    {
      icon: <ParksIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "National Parks",
      alt: "National Park",
      image: "/img/national.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks",
    },
    {
      icon: <StateParksIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }} />,
      title: "State Parks",
      alt: "State Park",
      image: "/img/state.jpg",
      link: "/utah-at-a-glance/utah-places-to-visit/utah-stateparks",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "stone-gate-bryce-canyon-national-park.webp",
          title: "Places to Visit in Utah",
          visible: "",
        }}
      />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Places to Visit in <br/> Utah ({iconData.length})</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah offers breathtaking destinations such as Zion National Park,
              Bryce Canyon, Arches, Monument Valley, and Salt Lake City, making
              it a haven for nature lovers, adventurers, and cultural explorers
              alike.
            </p>
            {/*             
                <ActionButton data="Explore More" /> */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-grow max-w-7xl mx-auto py-12 w-full">
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Discover Utah's Natural Wonders
          </h1>
          <p className="text-xl text-blue-700">
            Explore {iconData.length} breathtaking destinations across Utah
          </p>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 sm:px-6 lg:px-8">
          {iconData.map((item, index) => (
            <Link
              to={item.link}
              key={index}
              className="group relative block h-64 sm:h-72 rounded-xl overflow-hidden shadow-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl no-underline"
            >
              {/* Background Image */}
              <div
                className="absolute inset-0 bg-cover bg-center transform transition-transform duration-500 group-hover:scale-110 origin-center"
                style={{ backgroundImage: `url(${item.image})` }}
              >
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black/40 transition-all duration-300 group-hover:bg-black/30"></div>
              </div>

              {/* <div className="absolute inset-0 transform-gpu transition-transform duration-500 ease-in-out group-hover:scale-110"
                                style={{ backgroundImage: `url(${item.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}> */}
              {/* Dark overlay  */}
              {/* <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors duration-300" />
                            </div> */}

              {/* Content */}
              <div className="relative h-full flex flex-col items-center justify-center p-4 text-center z-10">
                <div className="text-[#FFAA1D]">{item.icon}</div>
                <h3 className="text-xl sm:text-2xl font-bold text-white drop-shadow-lg">
                  {item.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PlacesToVisit;
